module.exports = __webpack_public_path__ + "fa-regular-400.7630483dd4b0c48639d2.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-regular-400.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.eot
// module chunks = styles